import React from 'react'
import Box from '@material-ui/core/Box'
import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import FormControl from '@material-ui/core/FormControl'
import { CtrlPhone, CtrlTextField } from 'components/form-util'
import { secureLink } from 'lib/utils'
import AccountCard from './account-card'

const fieldProps = classes => ({
  variant: 'outlined',
  fullWidth: true,
  className: classes.accountField,
})

const getInitials = name => {
  const parts = name?.trim().split(/\s+/) || []
  if (parts.length >= 2) {
    return `${parts[0][0] || ''}${parts[parts.length - 1][0] || ''}`
  }
  return parts[0]?.substring(0, 2) || ''
}

const CardSaveActions = ({
  classes,
  hasErrors,
  updating,
  onSave,
  saveDisabled,
}) => (
  <Box className={classes.saveActions}>
    {hasErrors ? (
      <Typography className={classes.saveError}>
        Form has one or more errors
      </Typography>
    ) : null}
    <Button
      color={saveDisabled ? 'default' : 'primary'}
      variant="contained"
      className={`${classes.saveButton} ${
        saveDisabled ? classes.saveButtonInactive : ''
      }`}
      disabled={saveDisabled || updating}
      onClick={onSave}
    >
      Save
    </Button>
  </Box>
)

export const ProfileCard = ({
  form,
  coach,
  classes,
  hasErrors,
  updating,
  onSave,
  saveDisabled,
}) => {
  const { control, errors, register } = form
  const sharedFieldProps = fieldProps(classes)

  return (
    <AccountCard title="Profile" classes={classes}>
      <Avatar
        className={classes.avatar}
        src={secureLink(coach?.coachProfile?.profilePhoto)}
      >
        {getInitials(coach?.name)}
      </Avatar>
      <input name="coachId" type="hidden" ref={register()} />
      <FormControl fullWidth className={classes.fieldGroup}>
        <Typography
          className={classes.fieldLabel}
          component="label"
          htmlFor="name"
        >
          Display name
        </Typography>
        <CtrlTextField
          name="name"
          id="name"
          {...sharedFieldProps}
          {...{ control, errors }}
        />
        <Typography className={classes.fieldCaption}>
          How your name will appear on program communications and info
        </Typography>
      </FormControl>
      <CardSaveActions
        classes={classes}
        hasErrors={hasErrors}
        updating={updating}
        onSave={onSave}
        saveDisabled={saveDisabled}
      />
    </AccountCard>
  )
}

export const ContactPreferencesCard = ({
  form,
  classes,
  hasErrors,
  updating,
  onSave,
  saveDisabled,
}) => {
  const { control, errors } = form
  const sharedFieldProps = fieldProps(classes)

  return (
    <AccountCard title="Contact Preferences" classes={classes}>
      <FormControl fullWidth className={classes.fieldGroup}>
        <Typography
          className={classes.fieldLabel}
          component="label"
          htmlFor="email"
        >
          Email address
        </Typography>
        <CtrlTextField
          name="email"
          id="email"
          {...sharedFieldProps}
          {...{ control, errors }}
        />
        <Typography className={classes.fieldCaption}>
          Preferred email address for communications
        </Typography>
      </FormControl>
      <FormControl fullWidth className={classes.fieldGroup}>
        <Typography
          className={classes.fieldLabel}
          component="label"
          htmlFor="phone"
        >
          Phone number
        </Typography>
        <CtrlPhone
          name="phone"
          id="phone"
          {...sharedFieldProps}
          {...{ control, errors }}
        />
      </FormControl>
      <CardSaveActions
        classes={classes}
        hasErrors={hasErrors}
        updating={updating}
        onSave={onSave}
        saveDisabled={saveDisabled}
      />
    </AccountCard>
  )
}
